<template>
  <svg
    width="206"
    height="207"
    viewBox="0 0 206 207"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.14"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M116.312 52.2572C127.373 50.9546 125.738 67.9269 133.281 76.4661C139.265 83.2406 146.674 82.6909 150.54 91.0061C154.031 98.5149 141.935 104.459 137.72 111.609C134.44 117.174 133.962 124.856 128.616 128.205C123.292 131.539 116.372 126.418 110.55 128.626C97.2013 133.687 86.6555 155.077 73.7794 148.998C62.576 143.708 73.141 123.98 76.8021 111.575C79.3798 102.841 70.3952 85.5714 77.4855 80.2606C81.5525 77.2143 98.8564 78.8683 105.035 72.3407C111.213 65.8131 104.311 53.6704 116.312 52.2572Z"
      fill="#FFDA18"
    />
    <path
      opacity="0.1"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M47.6732 53.4272C65.1846 40.7328 82.2477 74.5109 102.988 73.1499C119.084 72.0936 128.632 45.7399 144.484 47.0741C159.696 48.3544 153.342 73.5001 160.594 86.3836C168.415 100.281 199.482 111.104 187.773 123.989C172.679 140.598 145.217 123.297 124.931 132.235C116.017 136.162 120.911 155.012 111.618 157.543C102.626 159.992 100.974 142.63 92.1324 141.168C76.8266 138.636 57.0163 156.763 45.8593 146.665C36.3648 138.071 54.9717 121.166 55.2324 107.769C55.6023 88.7538 31.5501 65.1151 47.6732 53.4272Z"
      fill="#EE8C32"
    />
    <g clip-path="url(#clip0_4078:17349)">
      <path
        d="M104.069 133H141.637C141.637 126.415 136.23 121.085 129.55 121.085H127.43C131.6 115.755 133.897 109.31 133.897 102.517C129.515 102.517 125.663 105.304 124.284 109.415C123.189 112.655 121.351 115.651 118.806 118.159C114.53 122.374 108.911 124.674 102.973 124.674C97.036 124.674 91.3814 122.374 87.1404 118.159C82.8994 113.944 80.5315 108.405 80.5315 102.552C80.5315 96.6992 82.8641 91.1253 87.1404 86.9448C89.685 84.4365 92.7244 82.5902 96.0111 81.545C100.181 80.1864 103.009 76.3891 103.009 72.0693C94.7035 72.0345 86.9637 75.2047 81.0617 80.9876C75.1596 86.7706 71.9789 94.4348 71.9789 102.517C71.9789 109.31 74.2407 115.755 78.4464 121.085H76.3612C69.6817 121.085 64.2744 126.415 64.2744 133H101.772C102.161 133 102.514 133.034 102.903 133.034C103.291 133.034 103.68 133.034 104.069 133Z"
        fill="url(#paint0_linear_4078:17349)"
      />
      <path
        d="M114.919 84.4043C117.261 84.4043 119.16 82.5326 119.16 80.2238C119.16 77.915 117.261 76.0433 114.919 76.0433C112.577 76.0433 110.678 77.915 110.678 80.2238C110.678 82.5326 112.577 84.4043 114.919 84.4043Z"
        fill="url(#paint1_linear_4078:17349)"
      />
      <path
        d="M126.087 95.169C128.429 95.169 130.328 93.2973 130.328 90.9885C130.328 88.6797 128.429 86.808 126.087 86.808C123.744 86.808 121.846 88.6797 121.846 90.9885C121.846 93.2973 123.744 95.169 126.087 95.169Z"
        fill="url(#paint2_linear_4078:17349)"
      />
      <path
        d="M127.43 121.088C126.617 122.133 125.733 123.108 124.779 124.049C119.195 129.553 111.88 132.724 104.069 133.002H141.602C141.602 126.418 136.195 121.088 129.515 121.088H127.43Z"
        fill="url(#paint3_linear_4078:17349)"
      />
      <path
        d="M102.973 133.037C103.327 133.037 103.645 133.037 103.998 133.002C103.645 133.037 103.327 133.037 102.973 133.037Z"
        fill="url(#paint4_linear_4078:17349)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4078:17349"
        x1="64.3895"
        y1="102.626"
        x2="141.752"
        y2="102.626"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00149187" stop-color="#FA8857" />
        <stop offset="0.9976" stop-color="#FFBA2E" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4078:17349"
        x1="110.691"
        y1="80.234"
        x2="119.173"
        y2="80.234"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00149187" stop-color="#FA8857" />
        <stop offset="0.9976" stop-color="#FFBA2E" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4078:17349"
        x1="121.858"
        y1="90.9987"
        x2="130.34"
        y2="90.9987"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00149187" stop-color="#FA8857" />
        <stop offset="0.9976" stop-color="#FFBA2E" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_4078:17349"
        x1="104.125"
        y1="127.06"
        x2="141.658"
        y2="127.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00149187" stop-color="#FA8857" />
        <stop offset="0.9976" stop-color="#FFBA2E" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_4078:17349"
        x1="102.975"
        y1="133.02"
        x2="104"
        y2="133.02"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00149187" stop-color="#FA8857" />
        <stop offset="0.9976" stop-color="#FFBA2E" />
      </linearGradient>
      <clipPath id="clip0_4078:17349">
        <rect
          width="77.3273"
          height="61"
          fill="white"
          transform="translate(64.2744 72.037)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  name: 'Logo2Icon'
}
</script>
